/**
 * Conversation id used to look up the chat chrome title.
 * Prefers the route id; falls back to the transport-captured id while `/chat/new`.
 */
export const resolveHeraldChatTitleConversationId = (
  conversationIdParam: string,
  activeConversationId: string | null,
): string | undefined => {
  const routeConversationId =
    conversationIdParam === "new" ? undefined : conversationIdParam;
  return routeConversationId ?? activeConversationId ?? undefined;
};
